export enum AuthProviderId {
  Google = 'google.com',
  Custom = 'custom'
}
